import { useModal } from '@features/Shared/Modal/_js/modal';

export function usePopupBlock(): void {
  const {showModal, setModalContent} = useModal();

  // Open modal
  document.querySelectorAll('.popup-block__open-modal').forEach((element) => {
    element.addEventListener('click', () => {
      
      showModal('modal-popup-block').then(() => {
        let modalId = (element as HTMLElement).dataset.popupBlockModalId;
        let template: string = document.getElementById('modal-' + modalId)?.innerHTML as string;

        setModalContent(template);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', usePopupBlock);